import {Component, Input, OnInit} from '@angular/core';
import {PrivatePerson} from '../../../model/private-person.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomerService} from '../../../../core/services/customer.service';
import {SnackBarService} from '../../../../core/services/snack-bar.service';
import {CustomValidators} from '../../../validator/customValidators';
import {AddressType} from "../../../model/interface/address-type.model.interface";

@Component({
  selector: 'app-new-private-person',
  templateUrl: './new-private-person.component.html',
  styleUrls: ['./new-private-person.component.css']
})
export class NewPrivatePersonComponent implements OnInit {
  @Input() standalone: boolean;
  @Input() privatePerson: PrivatePerson;
  @Input() requiredContact = false;
  personalInfo: FormGroup;
  AddressType = AddressType;

  constructor(private customerService: CustomerService,
              private formBuilder: FormBuilder,
              private snackBarService: SnackBarService) {
    this.createForm();
  }

  ngOnInit() {
    this.subscribeForm();
  }

  private createForm() {
    this.personalInfo = this.formBuilder.group({
      name: [null, [Validators.required, CustomValidators.nameValidator]],
      secondName: [null, CustomValidators.onlyLettersValidator],
      surname: [null, [Validators.required, CustomValidators.surnameValidator]],
      pesel: [null, [CustomValidators.peselValidator]],
      individualNumber: [null],
      mainAddress: [null, Validators.required],
      correspondenceAddress: [null]
    });
  }

  private subscribeForm() {
    this.personalInfo.valueChanges.subscribe(person => {
      if (this.personalInfo.valid) {
        this.privatePerson = new PrivatePerson(person);
      }
    });
  }
}
